import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import Slider from "react-slick";
import { Image } from "hesus-ui-kit";
import treatmentIcon from "@icons/ic-center-truck.svg";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import {
  TransportDetail,
  BlockRow,
  SliderGridRow,
  ProductLabel,
} from "../../WarehouseList.styled";
import "../../WarehouseList.scss";

const WarehouseTrucks = (props) => {
  const { t, trucks, status } = props;

  return (
    <BlockRow opacity={!status ? ".2" : 1}>
      {!!status && (trucks !== "" || trucks !== null) && (
        <Slider className="mainSlider" style={{ width: "100%" }}>
          {!trucks
            ? null
            : trucks.map((truck, index) => {
                return (
                  <div key={index}>
                    <SliderGridRow column="50px auto">
                      <Image
                        src={treatmentIcon}
                        alt={t("CENTRE_PRODUCT_PRICE_TREATMENT")}
                        title={t("CENTRE_PRODUCT_PRICE_TREATMENT")}
                        className="warehouses-list__transport-image-icon"
                      />

                      <div>
                        <ProductLabel>
                          {truck.count !== "" || truck.count !== null
                            ? truck.count
                            : " ? "}{" "}
                          {truck.truckType.name}
                        </ProductLabel>
                        <TransportDetail>
                          {truck.price +
                            " " +
                            truck.currency?.name +
                            "/" +
                            t(truck.unit)}
                        </TransportDetail>
                      </div>
                    </SliderGridRow>
                  </div>
                );
              })}
        </Slider>
      )}
      {!status && (
        <TransportDetail>{t("WAREHOUSE_TRUCKS_INACTIVE")}</TransportDetail>
      )}
      {!!status && (trucks === "" || trucks === null) && (
        <TransportDetail>{t("WAREHOUSE_NO_TRUCK")}</TransportDetail>
      )}
    </BlockRow>
  );
};

WarehouseTrucks.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(WarehouseTrucks);
